
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/sftp",
      function () {
        return require("private-next-pages/sources/sftp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/sftp"])
      });
    }
  